module.exports = __webpack_public_path__ + "fonts/YekanBakhFaNumMedium.cd93931.ttf";